import React, { useState, useEffect } from "react";
import "../../CSS/SingleChat.css";
import { Button, FormControl, IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { getSenderName, getSenderUser } from "../config/ChatLogics";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SendIcon from "@mui/icons-material/Send";
import ProfileModal from "../miscellaneous/ProfileModal";
import UpdateGroupModal from "../miscellaneous/UpdateGroupModal";
import Spinner from "react-bootstrap/Spinner";
import axios from "../axios";
import ScrollableChat from "./ScrollableChat";
import { Messaging } from "react-cssfx-loading";

import io from "socket.io-client";
//=============  Local server =============
// const ENDPOINT = "http://localhost:4000";

//=============  Live server =============
const ENDPOINT = "https://gupshup-chatapp.herokuapp.com/";

var socket, openedChatCompare;

const SingleChat = ({
  //All these are props coming ffrom Chatbox component
  userInfo,
  openChat,
  setOpenChat,
  getChatsAgain,
  setGetChatsAgain,
  windowWidth,
  notificationState,
  setNotificationState,
}) => {
  //   console.log("userInfo in singleChat",userInfo)
  const [profileModal, setProfileModal] = useState(false);
  const [updateGroupModal, setUpdateGroupModal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState();
  const [socketConnected, setSocketConnected] = useState(false);
  const [typing, setTyping] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [notification, setNotification] = useState([]);

  useEffect(() => {
    fetchMessages();
    openedChatCompare = openChat;
  }, [openChat]);
  useEffect(() => {
    socket = io(ENDPOINT);
    socket.emit("setup", userInfo);
    socket.on("connected", () => setSocketConnected(true));
    socket.on("typing", () => setIsTyping(true));
    socket.on("stop typing", () => setIsTyping(false));
    // socket.on("whoTyping", (arg) => {
    //   if (arg && arg !== null && arg !== undefined) {
    //     console.log("arg", arg);
    //   }
    // });
    // console.log("socket",socket)
  }, []);
  useEffect(() => {
    socket.on("message recieved", (newMessageRecieved) => {
      // console.log("newMessageRecieved", newMessageRecieved);
      if (
        !openedChatCompare ||
        openedChatCompare._id !== newMessageRecieved.chat[0]._id
      ) {
        //give notification
        if (!notification.includes(newMessageRecieved)) {
          // console.log("newMessageRecieved2", newMessageRecieved);
          // setNotification([newMessageRecieved, ...notification]);
          setNotificationState([newMessageRecieved, ...notification]);
          setGetChatsAgain(!getChatsAgain);
        }
      } else {
        setMessages([...messages, newMessageRecieved]);
      }
    });
    setNotification(notificationState);
  });
  const fetchMessages = async () => {
    if (!openChat) return;

    try {
      setLoading(true);
      setNewMessage("");
      const token = userInfo.token;
      await axios
        .get(`/message/${openChat._id}`, {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // console.log("res of fetch msg", res.data);
          setMessages(res.data);
          // setSelectedChat(res.data);
          // props.selectedChatHandler(res.data);
        });
      setLoading(false);
      // setDrawerState(false);
      socket.emit("join chat", openChat._id);
    } catch (error) {
      console.log("Error Occured white trying to send message", error);
    }
  };
  const sendMessage = async (event) => {
    console.log("event.key", event.key);
    // if (!newMessage.replace(/\s/g, '').length) {
    //   console.log('string only contains whitespace (ie. spaces, tabs or line breaks)');
    // } //NotWorked
    // if (/\S/.test(newMessage)) {
    //   // string is not empty and not just whitespace
    // } //NotWorked
    if (!newMessage.trim().length) {
      console.log(" only white-spaces");
      return;
    }
    if ((event.key === undefined || event.key === "Enter") && newMessage) {
      socket.emit("stop typing", openChat._id);
      try {
        // setLoadingChat(true);

        setNewMessage("");
        const token = userInfo.token;
        await axios
          .post(
            "/message/",
            { content: newMessage, chatId: openChat._id },
            {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            // console.log("res of msg snd", res.data);
            socket.emit("new message", res.data);
            setMessages([...messages, res.data]);
            // setSelectedChat(res.data);
            // props.selectedChatHandler(res.data);
          });
        // setLoadingChat(false);
        // setDrawerState(false);
      } catch (error) {
        console.log("Error Occured white trying to send message", error);
      }
    }
  };
  const messageTyping = (e) => {
    // console.log(e.target.value)

    setNewMessage(e.target.value);
    // console.log("typing before", typing);

    //typing indicator
    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", openChat._id);
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 2000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", openChat._id);
        setTyping(false);
      }
    }, timerLength);
  };
  // console.log("---------", notification);
  ////////////////////// Return //////////////////////
  return (
    <>
      {openChat ? (
        <>
          <div className="single_chat_box">
            {windowWidth <= "850" ? (
              <Button onClick={() => setOpenChat("")}>
                <KeyboardBackspaceIcon />
              </Button>
            ) : null}
            <div className="chat_name">
              {!openChat.isGroupChat ? (
                <>{getSenderName(userInfo, openChat.users)}</>
              ) : (
                <>{openChat.chatName.toUpperCase()}</>
              )}
            </div>
            {/* <p>Chat Name</p> */}
            {!openChat.isGroupChat ? (
              <div className="chat_box_eye_btn">
                <IconButton onClick={() => setProfileModal(true)}>
                  <VisibilityIcon style={{ fontSize: "25px" }}></VisibilityIcon>
                </IconButton>
                {profileModal ? (
                  <ProfileModal
                    userInfo={getSenderUser(userInfo, openChat.users)}
                    profileModal={profileModal}
                    setProfileModal={setProfileModal}
                  />
                ) : null}
              </div>
            ) : (
              <div className="chat_box_eye_btn">
                <IconButton onClick={() => setUpdateGroupModal(true)}>
                  <VisibilityIcon style={{ fontSize: "25px" }}></VisibilityIcon>
                </IconButton>
                {updateGroupModal ? (
                  <UpdateGroupModal
                    userInfo={userInfo}
                    updateGroupModal={updateGroupModal}
                    setUpdateGroupModal={setUpdateGroupModal}
                    openChat={openChat}
                    setOpenChat={setOpenChat}
                    getChatsAgain={getChatsAgain}
                    setGetChatsAgain={setGetChatsAgain}
                    fetchMessages={fetchMessages}
                  />
                ) : null}
              </div>
            )}
          </div>
          <div className="chat_box_messages_container">
            <div className="chat_box_messages">
              {loading ? (
                <>
                  <div className="chat_box_spinner">
                    <Spinner
                      animation="border"
                      variant="secondary"
                      style={{ height: "100px", width: "100px" }}
                    />
                  </div>
                </>
              ) : (
                <div>
                  <div className="chat_box_messages_inner">
                    {/* {messages ? (
                      <ScrollableChat messages={messages} userInfo={userInfo} />
                    ) : null} */}
                    <ScrollableChat messages={messages} userInfo={userInfo} />
                  </div>
                </div>
              )}
              <FormControl onKeyDown={sendMessage}>
                <div className="message_input">
                  {isTyping ? (
                    <div style={{ margin: "0 0 15px 10px" }}>
                      <Messaging
                        color="#38b2ac8f"
                        width="10px"
                        height="10px"
                        duration="0.7s"
                      />
                    </div>
                  ) : null}
                  <div className="message_input_inner">
                    <input
                      className="form-control"
                      placeholder="Enter a message..."
                      onChange={messageTyping}
                      value={newMessage}
                      style={{ background: "#E0E0E0" }}
                    ></input>
                    <div className="send_msg_btn" onClick={sendMessage}>
                      <SendIcon />
                    </div>
                  </div>
                </div>
              </FormControl>
            </div>
          </div>
        </>
      ) : (
        <div className="empty_chat_box">
          <div className="empty_chat_box_msg">Click a user to start chat</div>
        </div>
      )}
    </>
  );
};

export default SingleChat;
